import localforage from 'localforage';

const DATABASE_NAME = 'Wegroup - Broker platform';

export const proFlowStorage = localforage.createInstance({
  name: DATABASE_NAME,
  storeName: 'pro_flow',
});
